import { getAppEnv } from "@/lib/getBrowserEnv";
import { callKNBBridge, checkKNBBridgeEnable, initKNBBridge, callKNBUseBridge } from "./knb";
import { callMSIBridge, checkMSIBridgeEnable, initMSIBridge } from "./msi";
import { initWXBridge } from "./wx";
import { callGrowthMSIBridge, checkGrowthMSIBridgeEnable, initGrowthMSIBridge } from "./growthMsi";

enum BridgeType {
  KNB = "KNB", // Titans 容器 KNB 桥
  MSI = "MSI", // 标准化 KNB 容器的 MSI 桥
  GROWTH_MSI = "GROWTH_MSI", // 外投容器的 MSI 桥
  UNKNOWN = "UNKNOWN",
}

function initBridge() {
  const appEnv = getAppEnv();
  if (appEnv.isTitansContainer) {
    initKNBBridge();
  } else if (appEnv.isStandardKNBContainer) {
    initMSIBridge();
  } else if (appEnv.isGrowthContainer) {
    initGrowthMSIBridge();
  } else if (appEnv.isWXContainer) {
    initWXBridge();
  }
}

function getBridgeType(): BridgeType {
  const appEnv = getAppEnv();
  if (appEnv.isTitansContainer) {
    return BridgeType.KNB;
  } else if (appEnv.isStandardKNBContainer) {
    return BridgeType.MSI;
  } else if (appEnv.isGrowthContainer) {
    return BridgeType.GROWTH_MSI;
  }
  return BridgeType.UNKNOWN;
}

export {
  BridgeType,
  initBridge,
  getBridgeType,
  checkKNBBridgeEnable,
  checkMSIBridgeEnable,
  checkGrowthMSIBridgeEnable,
  callKNBBridge,
  callKNBUseBridge,
  callMSIBridge,
  callGrowthMSIBridge,
}